import { formatPayloadDate } from 'utils/helpers'

export const toAssignmentPayload = (values, personId, status) => ({
  jobTitle: values.jobTitle,
  startDate: formatPayloadDate(values.startDate),
  ...(values.endDate && { endDate: formatPayloadDate(values.endDate) }),
  extensionPeriod: values.extensionPeriod * 30, // Convert months to days
  adAccount: values.adAccount,
  googleAccount: values.googleAccount,
  ldapAccount: values.ldapAccount,
  ...(values.updateComment && { updateComment: values.updateComment }),
  person: {
    id: personId
  },
  manager: {
    id: values.manager.value
  },
  externalPartnerType: {
    id: values.externalPartnerType.value
  },
  legalEntity: {
    ...(values.legalEntityId && { id: values.legalEntityId }),
    ...(values.legalEntityName && { name: values.legalEntityName }),
    ...(values.legalEntityCIF && { code: values.legalEntityCIF }),
    ...(values.legalEntityCountry && { country: { id: values.legalEntityCountry.value } }),
    isEnabled: true
  },
  ...(values.store && { stores: values.store.map(s => ({ id: s.value })) }),
  ...(values.delegate && { delegate: { id: values.delegate.value } }),
  status: { id: status },
  details: values.assignmentDetails
})
